/**
 * @deprecated
 * @param inputString
 */
export const hasMultipleSqlStatement = (inputString: string | undefined): boolean => {
  if (!inputString) return false
  const semicolonCount = inputString.split(';').length - 1
  return semicolonCount > 1
}
